/** Decorative Video picto: light circle, dark play. Not a control. */
export default function VideoPicto() {
  return (
    <span
      data-video-picto=""
      aria-hidden="true"
      className="pointer-events-none absolute right-3 top-3 z-[15] flex h-9 w-9 items-center justify-center rounded-full bg-[#E8F0E4]/70"
    >
      <svg width="12" height="14" viewBox="0 0 12 14" fill="none" aria-hidden="true">
        <path d="M11.5 7L1 13.2V.8L11.5 7Z" fill="#003F28" />
      </svg>
    </span>
  );
}

export function hasVerifiedVideo(videoStatus: string | undefined): boolean {
  return videoStatus === "verified";
}
